import { apiClient } from "../apiClient";

const HOC_KY_DANG_KY_ENDPOINT =  "hoc-ky-dang-ky";
export const hocKyDangKyApi = {
    SelectAll: () => apiClient.get(`${HOC_KY_DANG_KY_ENDPOINT}`),
}